// Compact number formatting used across the app so large counts never break
// layouts (e.g. followers, members, views, reactions, donation totals).
// Values below 10 000 stay exact (they fit fine); 10 000+ switch to k / M.
// 9999 -> "9999", 12000 -> "12k", 120000 -> "120k", 999999 -> "1M", 1200000 -> "1,2M".
// Uses a comma as the decimal mark (matches the FR-first UI).

const trim = (num) => {
  // 1 decimal, dropping a trailing ",0" (e.g. 1,0M -> 1M) and using a comma.
  const s = num.toFixed(1).replace(/\.0$/, "");
  return s.replace(".", ",");
};

const compact = (value) => {
  const n = Math.round(Number(value) || 0);
  const abs = Math.abs(n);
  if (abs >= 1000000) return `${trim(n / 1000000)}M`;
  if (abs >= 10000) {
    const k = Math.round(n / 1000);
    // Guard the round-up into millions (e.g. 999 999 -> "1M", not "1000k").
    if (Math.abs(k) >= 1000) return `${trim(n / 1000000)}M`;
    return `${k}k`;
  }
  return `${n}`;
};

// Compact a raw count (followers, members, views, reactions…).
export const compactNumber = compact;

// Compact a money total (currency symbol added by the caller, e.g. `${compactMoney(x)} $`).
export const compactMoney = compact;
